import PropTypes from 'prop-types';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import './DropdownMenuButton.scss';

export const DropdownMenuButton = (props) => {
  const { isMenuOpen, menuButtonClickHandler, chosenValue, extendClass = '' } = props;
  const menuOpenClass = isMenuOpen ? 'dropdown-button--open' : '';
  const classes = [
    'dropdown-button',
    menuOpenClass,
    extendClass ? `${extendClass}--button` : '',
  ].join(' ');

  return (
    <button
      type="button"
      aria-controls={isMenuOpen && 'dropdown-menu'}
      aria-haspopup="true"
      aria-expanded={isMenuOpen && 'true'}
      onClick={menuButtonClickHandler}
      className={classes}
      data-testid="dropdown-button"
    >
      <span className="text">{chosenValue}</span>
      <span className="arrow-container">
        <ArrowDropDownIcon className="icon" />
      </span>
    </button>
  );
};

DropdownMenuButton.propTypes = {
  isMenuOpen: PropTypes.bool,
  menuButtonClickHandler: PropTypes.func,
  chosenValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  extendClass: PropTypes.string,
};
